import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Link } from '../../component-link';
import { forwardRef } from 'react';
/**
 * Is used to display links within the `FooterLegalLinkList`.
 */
export const FooterLegalLink = forwardRef((props, ref) => (_jsx(Link, { size: "md", variant: "neutral", ...props, ref: ref })));
FooterLegalLink.displayName = 'FooterLegalLink';
